import './CvAnonyme.scss';

import { Download } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
//import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { AppBar, Button, ScopedCssBaseline, Stack, Toolbar, Tooltip } from '@mui/material';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import jsPDF from 'jspdf';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

//import  from '../../../src/Assets/LOGOHTH.png';
import logoDataDelegates from '../../../src/Assets/LOGOHTH.png';
import { getFournisseurInfo, niveauxLangue, niveauxSkill, typeDiplomeEnum } from '../../data/Interfaces';
import useAuth from '../../hooks/useAuth';
import usePostRequest from '../../hooks/usePostRequest';
import useWindowSize from '../../hooks/useWindowSize';
import { ordreMissionStyles } from '../../Styles/componentStyles';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
// import { Preview } from 'react-html2pdf';
import { getNomPrenomAnonymeFromPersoData, groupBy, isHttpStatusSuccess, ordrePlusRecenteAuAncien, searchLabelInEnumByValue } from '../../Utils/utils';
import { buttonStyles,buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import QuillAdvancedTextArea from '../shared/QuillAdvancedTextArea';
import { TextFieldComponent, Transition } from '../shared/ReusableSmallComponents';
import { CvAnonymeStyle } from './CvAnonymeStyles';

export const getMyNote = ({ noteList, collaboratorId }) => {
    // alert(Array.isArray(noteList));
    // setNote(noteList.find(noteObj => noteObj.collaboratorId == auth?.collaboratorId));
    if(Array.isArray(noteList) )
        if(collaboratorId)
            return noteList.find(noteObj => noteObj.collaboratorId?._id == collaboratorId || noteObj.collaboratorId == collaboratorId);
        else {
            const { sum, count } = noteList.reduce((acc, note) => {
                if (note.evaluation !== '') {
                    acc.sum += parseInt(note.evaluation);
                    acc.count++;
                }
                return acc;
            }, { sum: 0, count: 0 });
            const average = count > 0 ? sum / count : 0;
            return average;
        }
};

//mode : cvTheque (pour masquer la partie motivation)
const CvAnonyme = ({ openCvAnonyme,  visualiseCvOnly, setOpenCvAnonyme, expert, mode, titreAO,
    selectedCandidature, refreshParentTable, children,necessaryRefresh }) => {

    CvAnonyme.propTypes = {
        openCvAnonyme: PropTypes.any,
        selectedCandidature: PropTypes.any,
        visualiseCvOnly: PropTypes.bool,
        setOpenCvAnonyme: PropTypes.func,
        refreshParentTable: PropTypes.func,
        necessaryRefresh:PropTypes.any,
        expert: PropTypes.any,
        titreAO: PropTypes.any,
        children: PropTypes.any,
        mode: PropTypes.any,
    };
    const { postData } = usePostRequest();
    const descriptionElementRef = React.useRef(null);
    const [commentaire, setCommentaire] = useState('');
    const [GroupedTechSkills, setGroupedTechSkills] = useState([]);
    const [experiencesSorted,setExperienceSorted]=useState([]);
    const [diplomesSorted,setDiplomesSorted]=useState([]);
    const [formationsSorted,setFormationsSorted]=useState([]);
    const selectedAnonymeExpert = getNomPrenomAnonymeFromPersoData(expert?.persoData);
    const [evaluation, setEvaluation] = useState(4.5);
    const [argumentCommercial,setArgumentCommercial] = useState('');
    const {device}=useWindowSize();
    const scroll = 'paper';
    const { auth } = useAuth();
    const { i18n } = useTranslation();
    useEffect(() => {
        // alert(JSON.stringify(auth?.collaboratorId));
        const collaboratorId = auth?.collaboratorId ; //?? this may work for admin/dossier, since each dossier is linked to a collab : selectedCandidature?.collaboratorId
        setCommentaire(getMyNote({ noteList: selectedCandidature?.note, collaboratorId: collaboratorId })?.commentaire);
        setEvaluation(getMyNote({ noteList: selectedCandidature?.note, collaboratorId: collaboratorId })?.evaluation);
        setArgumentCommercial(selectedCandidature?.argumentCommercial);

    }, [selectedCandidature]);

    useEffect(() => {
        console.log('lahsen test here', expert?.proData);
        // const filteredSkill = {} //btw it's grouped, not filtred
        // ? https://stackoverflow.com/questions/21776389/javascript-object-grouping
        // ? used to group the skills array BY NIVEAU [debutant ..]
        console.log(groupBy(expert?.proData?.competencesTechnique, 'niveau'));
        setGroupedTechSkills(groupBy(expert?.proData?.competencesTechnique, 'niveau'));
        console.log('experiences avant',expert?.proData?.experiences);
        //console.log('experiencesSorted',ordrePlusRecenteAuAncien(expert?.proData?.experiences));
        setExperienceSorted(ordrePlusRecenteAuAncien(expert?.proData?.experiences));
        setDiplomesSorted(ordrePlusRecenteAuAncien(expert?.proData?.etudesEtDiplomes));
        setFormationsSorted(ordrePlusRecenteAuAncien(expert?.proData?.formationEtCertificats));
    }, [expert]);

    // useEffect(() => {
    //     console.log('GroupedTechSkills');
    //     console.log(typeof GroupedTechSkills);
    //     if (GroupedTechSkills)
    //         GroupedTechSkills.map((skill, i) => {
    //             console.log({ skill, i });
    //         });
    // }, [GroupedTechSkills]);

    // ? we focus on what here
    useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    const handleGeneratePdf = () => {
        const doc = new jsPDF({
            format: 'a2',
            unit: 'px',
        });
        doc.html(document.getElementById('personalcv'),
            {
                async callback(doc) {
                    const pageCount = doc.internal.getNumberOfPages();
                    for (let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        doc.text(`${i} / ${pageCount}`, doc.internal.pageSize.getWidth() - 50, doc.internal.pageSize.getHeight() - 20);
                    }
                    await doc.save(expert?.persoData?.intitulePoste);
                },

                //async callback(doc) {
                //    await doc.save('document');
                //    //setPropoCommLoaded(false);
                //},
                // [top, left, bottom, right]
                margin:[50,10,40,50],
                autoPaging:'text',
            });
    };

    const handleCloseCvAnonyme = () => {
        setOpenCvAnonyme(false);
        // ! performance issue
        if(necessaryRefresh==true)
            if (refreshParentTable instanceof Function)
                refreshParentTable();
    };

    const getChargeRecrutementInfos = (expert,Info) => {
        if(expert?.esnId?.backOfficeId?.persoData != null){
            if(Info=='name')
                return expert?.esnId?.backOfficeId?.persoData?.nom?.charAt(0).toUpperCase() + '.'+expert?.esnId?.backOfficeId?.persoData?.prenom;
            else if(Info=='tele')
                return expert?.esnId?.backOfficeId?.persoData?.tele;
            else
                return expert?.esnId?.backOfficeId?.persoData?.email;
        }
        else if (expert?.esnId  && expert.esnId.backOfficeId == null){
            if(Info=='name')
                return getFournisseurInfo(auth?.email).chargeRecrutement;
            else if (Info=='tele')
                return getFournisseurInfo(auth?.email).tele;
            else
                return getFournisseurInfo(auth?.email).email;
        }
        else
            return '';
    }  ;

    const handleSaveEvaluation = async () => {
        console.log(selectedCandidature);
        const response1 = await postData({
            url: '/candidature/updateCandidatureEvaluation',
            payload: {
                expertId: expert?._id ?? expert?.expertId,
                candidatureId: selectedCandidature?._id,
                commentaire,
                evaluation
            }
        });
        console.log(response1);
        if (isHttpStatusSuccess(response1.responseStatus)) {
            setOpenCvAnonyme(false);
            // if(necessaryRefresh==true)
            // * the refresh will be just if we update smthg in the candidature.
            if (refreshParentTable instanceof Function)
                refreshParentTable();
        }
    };
    return (
        <Dialog
            fullScreen
            open={openCvAnonyme}
            TransitionComponent={Transition}
            onClose={handleCloseCvAnonyme}
            scroll={scroll}
            PaperProps={{
                style: {
                    background: '#F5F6FA',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleCloseCvAnonyme}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <div style={{ display: 'flex', flexDirection:device=='desktop'?'row':'column', justifyContent: 'space-around', background: '#F5F6FA', paddingTop: '90px', paddingLeft: '24px',paddingRight: device=='desktop'?'0px':'24px', paddingBottom: '24px',gap:device=='desktop'?'0px':'16px'}}>
                <div className='frame1bdc'>
                    <div
                        id='personalcv'
                        //style={CvAnonymeStyle.cvpagepreview}
                        style={ordreMissionStyles.page}
                    >
                        <ScopedCssBaseline>
                            <div
                                style={{ display:'flex',
                                    flexDirection:'row',
                                    alignItems:'flex-start',
                                    justifyContent:'space-between',
                                    alignSelf:'stretch',
                                    gap:'8px',}}
                            >
                                {/*style={ordreMissionStyles.FileFrame1Box1AppWidth}>*/}
                                <div
                                    style={CvAnonymeStyle.logo}
                                >
                                    {/*<img src={png}/> hth */}
                                    <img src={logoDataDelegates}/>
                                    {/*<Logo />*/}
                                </div>
                                <div style={ordreMissionStyles.OrdreMissionFileSousTitlesAppWidth}>
                                    {getChargeRecrutementInfos(expert,'name')!='' &&
                                        <p
                                            style={{ fontFamily:'Lato',
                                                fontStyle:'normal',
                                                fontWeight:'400',
                                                fontSize:'14px',
                                                display:'flex',
                                                letterSpacing:'-0.0044em',
                                                color:'#5B8AC1',
                                                margin:0,
                                            }}
                                        >
                                            {/* TODO :charge de recrutement liee au client*/}
                                            {i18n.t('Contact ')}:&nbsp;&nbsp;{getChargeRecrutementInfos(expert,'name')}
                                            {/* {i18n.t('Contact')}:&nbsp;&nbsp;{getFournisseurInfo(auth?.email).chargeRecrutement}  */}
                                        </p>
                                    }
                                    {getChargeRecrutementInfos(expert,'tele')!='' &&
                                        <p
                                            style={{ fontFamily:'Lato',
                                                fontStyle:'normal',
                                                fontWeight:'400',
                                                fontSize:'14px',
                                                display:'flex',
                                                letterSpacing:'-0.0044em',
                                                color:'#5B8AC1',
                                                margin:0,
                                            }}
                                        >
                                            {i18n.t('Tél')}:&nbsp;&nbsp;{getChargeRecrutementInfos(expert,'tele')}
                                            {/* {i18n.t('Tél')}:&nbsp;&nbsp;{getFournisseurInfo(auth?.email).tele} */}

                                        </p>
                                    }
                                    {getChargeRecrutementInfos(expert,'email')!='' &&
                                        <p
                                            style={{ fontFamily:'Lato',
                                                fontStyle:'normal',
                                                fontWeight:'400',
                                                fontSize:'14px',
                                                display:'flex',
                                                letterSpacing:'-0.0044em',
                                                color:'#5B8AC1',
                                                margin:0,
                                            }}
                                        >
                                            {getChargeRecrutementInfos(expert,'email')}
                                            {/* {getFournisseurInfo(auth?.email).email} */}
                                        </p>
                                    }
                                </div>
                            </div>
                            {/*Contact : F.MOUTTAKI
                            Tél : 01 47 25 59 46 – Mob: 06 14 51 79 14
                            f.mouttaki@HighTechHires.com*/}
                            <div style={CvAnonymeStyle.allcvcontent}>
                                <h5 style={CvAnonymeStyle.titleposte}>{expert?.persoData?.intitulePoste}</h5>
                                {expert?.persoData?.SyntheseProfile &&
                            <div
                                style={CvAnonymeStyle.styleTitre}
                            >
                                <p style={CvAnonymeStyle.competences}>
                                    {i18n.t('SYNTHESE DU PROFIL')}
                                </p>
                                <p style={CvAnonymeStyle.synthtxtcolor}>{expert?.persoData?.SyntheseProfile}</p>
                            </div>}
                                {(expert?.proData?.competencesTechnique.length>0 ||expert?.proData?.competencesFonctionnel.length>0) &&
                                    <div
                                        style={CvAnonymeStyle.styleTitre}
                                    >
                                        <p style = {CvAnonymeStyle.competences}>
                                            {i18n.t('COMPETENCES')}
                                        </p>
                                    </div>
                                }
                                {expert?.proData?.competencesTechnique.length>0 &&
                                    <>
                                        <p style={CvAnonymeStyle.subtitleStyle}>{i18n.t('Compétences techniques')}</p>
                                        <table style={CvAnonymeStyle.tabstyle}>
                                            <thead>
                                                <tr>
                                                    <th style={CvAnonymeStyle.columnstyle}>{i18n.t('Compétence(s)')} </th>
                                                    <th style={{color:'#5B8AC1'}}>{i18n.t('Niveau')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(GroupedTechSkills) && GroupedTechSkills.map((skill, i) => (
                                                    <tr key={i}>
                                                        <td style={{fontFamily:'Lato'}}>
                                                            {skill.map((skl, index) => (
                                                                index == skill.length-1 ?
                                                                    <span key={index}>{skl?.titre || '--'}</span>
                                                                    :
                                                                    <span key={index}>{skl?.titre + ', ' || '--'}</span>
                                                            ))}
                                                        </td>
                                                        <td style={{fontFamily:'Lato'}}>{searchLabelInEnumByValue(niveauxSkill,skill[0].niveau)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>
                                }

                                {expert?.proData?.competencesFonctionnel.length>0 &&
                                    <>
                                        <p style={CvAnonymeStyle.subtitleStyle}>{i18n.t('Compétences fonctionnelles')}</p>
                                        <table style={CvAnonymeStyle.tabstyle}>
                                            <tr>
                                                <th style={CvAnonymeStyle.columnstyle}>{i18n.t('Compétence(s)')} </th>
                                                <th style={{ color: '#5B8AC1' }}>{i18n.t('Niveau')}</th>
                                            </tr>
                                            <tbody>
                                                {expert?.proData?.competencesFonctionnel.map((skill, i) => (
                                                    <tr key={i}>
                                                        <td style={{fontFamily:'Lato'}}>{skill.titre}</td>
                                                        <td style={{fontFamily:'Lato'}}>{searchLabelInEnumByValue(niveauxSkill,skill?.niveau)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>
                                }
                                {expert?.proData?.experiences.length>0 &&
                                (
                                    <>
                                        <div
                                            style={CvAnonymeStyle.styleTitre}
                                        >
                                            <p style = {CvAnonymeStyle.competences}>
                                                {i18n.t('EXPERIENCES')}
                                            </p>
                                        </div>
                                        <div>

                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                {Array.isArray(expert?.proData?.experiences) && experiencesSorted.map((experience, i) => (
                                                    <div key={i}>
                                                        <p style={{margin:0,fontFamily:'Lato'}}>{experience?.entreprise}</p>
                                                        <p style={{color: '#1B6B90',fontFamily:'Lato',margin:0}}>{formatDateJJMMYYYY(experience?.dateDebut)} - {experience?.isEncours ? 'Aujourd\'hui' : formatDateJJMMYYYY(experience?.dateFin)}   {experience?.localisation}</p>
                                                        {/*<p>{experience.description}</p>*/}
                                                        <p style={{margin:0,fontFamily:'Lato'}}>{experience?.intitulePoste}</p>
                                                        <QuillAdvancedTextArea
                                                            value={experience?.description || i18n.t('pas de description')}
                                                            readOnly={true}
                                                            theme='bubble'
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </>
                                )
                                }
                                {expert?.proData?.etudesEtDiplomes.length>0 &&
                                (
                                    <>
                                        <div
                                            style={CvAnonymeStyle.styleTitre}
                                        >
                                            <p style = {CvAnonymeStyle.competences}>
                                                {i18n.t('ETUDES & DIPLOMES')}
                                            </p>
                                        </div>
                                        <div>
                                            <div style={{display:'flex',flexDirection:'column',gap:'16px'}}>
                                                {Array.isArray(expert?.proData?.etudesEtDiplomes) && diplomesSorted.map((education, i) => (
                                                    <div key={i}>
                                                        <div style={{display:'flex',flexDirection:'row',gap:'8px'}}>
                                                            <p style={{color: '#34349A',margin:0,fontFamily:'Lato'}}>{formatDateJJMMYYYY(education?.dateFin)} </p>
                                                            {(education?.type || education?.universite ||education?.formation) &&
                                                            <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
                                                                {(education?.type || education?.universite) &&
                                                                <>
                                                                    <p style={{margin:0,fontFamily:'Lato'}}>{searchLabelInEnumByValue(typeDiplomeEnum,education?.type)} - {education?.universite}</p>
                                                                </>
                                                                }
                                                                {education?.formation &&
                                                                <p style={{margin:0,color:'#686868',fontFamily:'Lato',paddingLeft:'24px'}}>{education?.formation}</p>
                                                                }
                                                            </div>
                                                            }
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </>
                                )}
                                {expert?.proData?.formationEtCertificats.length>0 &&
                                    (<>
                                        <div
                                            style={CvAnonymeStyle.styleTitre}
                                        >
                                            <p style = {CvAnonymeStyle.competences}>
                                                {i18n.t('FORMATION & CERTIFICATS')}
                                            </p>
                                        </div>
                                        <div>
                                            <>
                                                {Array.isArray(expert?.proData?.formationEtCertificats) && formationsSorted.map((certif, i) => (
                                                    <div
                                                        key={i}
                                                        style={{display:'flex',flexDirection:'row',gap:'8px'}}
                                                    >
                                                        <p style={{color: '#34349A',margin:0,fontFamily:'Lato',width:'188px'}}>{formatDateJJMMYYYY(certif?.dateFin)} </p>
                                                        <p style={{margin:0,fontFamily:'Lato'}}>{certif?.titre}</p>
                                                    </div>
                                                ))}
                                            </>
                                        </div>
                                    </>)
                                }
                                {expert?.proData?.langues.length>0 &&
                                (<>
                                    <div
                                        style={CvAnonymeStyle.styleTitre}
                                    >
                                        <p style = {CvAnonymeStyle.competences}>
                                            {i18n.t('LANGUES')}
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            {Array.isArray(expert?.proData?.langues) && expert?.proData?.langues.map((language, i) => (
                                                <div key={i}>
                                                    <p>
                                                        <b>{language.langue}</b>&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp; <b>{searchLabelInEnumByValue(niveauxLangue,language?.niveau)}</b>
                                                    </p>
                                                </div>
                                            ))}
                                        </p>
                                    </div>
                                </>)
                                }
                            </div>
                        </ScopedCssBaseline>
                        {/*</div>*/}
                    </div>
                </div>
                {device!='desktop' &&
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignSelf: 'stretch',
                            justifyContent: ' flex-start',
                            alignItems: 'center',
                            width:'100%',
                            order:3,
                        }}
                    >
                        <Button
                            variant='contained'
                            startIcon={<Download />}
                            color='success'
                            style={{ ...buttonStylesGreen(false),...{width:'100%'} }}
                            onClick={handleGeneratePdf}
                        >Télécharger</Button>
                        {/*masquer pour v0*/}
                        {/*<Button >
                            <ShareOutlinedIcon style={{ color: '#272D3C' }} />
                        </Button>*/}
                    </div>
                }

                <div className='rightBoxCvAnonym'>
                    <>

                        {device!='desktop' &&
                            <div style={{display:'flex',flexDirection:'column',gap:'30px',width:'100%'}}>
                                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                                    <h5 className='TitleFrame1OM'>
                                        CV
                                    </h5>
                                    <IconButton
                                        //className='TelechargerMissionOM'
                                        //onClick={printOrdreMission}
                                        onClick={handleGeneratePdf}
                                        variant="outlined"
                                        style={{...buttonStyles(),...{color:'#214DCE',border: '1px solid #214DCE',order:2,margin:'0'}}}

                                        //startIcon={<FileDownloadOutlinedIcon style={{color:'#214DCE',margin:'0px'}} />}
                                        //onClick={handleExportWithComponent}
                                    >
                                        <FileDownloadOutlinedIcon style={{color:'#214DCE',margin:'0px'}} />
                                    </IconButton>
                                </div>
                                <div style={{borderBottom:'solid 2px #C3C9F1',margin:'0px'}}></div>
                            </div>
                        }
                        <div className='aotitlestyle'>
                            <p className='nomcvabrv' >{selectedAnonymeExpert}</p>
                            <p
                                className='titleoffercv'
                                style={{ margin: 0 }}
                            >{titreAO || ''}</p>
                        </div>

                        {device=='desktop' &&
                            <div className='firsthspacer' ></div>
                        }

                        <div className='allaoactions'>
                            {mode=='candidature' &&
                                <div style={{display:'flex',flexDirection:'column',alignSelf:'stretch',gap:'8px'}}>
                                    <p
                                        className='evalstyletxt'
                                        style={{margin:'0'}}
                                    >{i18n.t('Présentation et motivation')}</p>
                                    <div className='Frame4OMBox1OM'>
                                        <QuillAdvancedTextArea
                                            value={argumentCommercial || ' '}
                                            readOnly={true}
                                            className='Frame4Box1ContentOM'
                                            theme='bubble'
                                        />
                                    </div>
                                </div>
                            }
                            {!visualiseCvOnly &&
                                <>
                                    <Box>
                                        <Typography
                                            omponent="legend"
                                        //style={{marginBottom: '-20px'}}
                                        ><p className='evalstyletxt'>{i18n.t('Evaluer CV')}</p></Typography>
                                        <Rating
                                            //style = {{ marginTop: '10px'}}
                                            precision={0.5}
                                            name="simple-controlled"
                                            // defaultValue={note?.evaluation}
                                            value={evaluation}
                                            onChange={(event, newValue) => {
                                                setEvaluation(newValue);
                                            }}
                                            sx={{ '& .css-dqr9h-MuiRating-label': { display: 'block', borderRadius: '4px' } }}
                                        />
                                    </Box>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '8px',
                                            alignSelf: 'stretch',
                                        }}
                                    >
                                        <label
                                            className='evalstyletxt'
                                            style={{ margin: 0 }}
                                        > {i18n.t('Statut de la candidature')}</label>
                                        <div style={{ display: 'flex', alignSelf: 'stretch' }}>{children}</div>
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '8px',
                                            alignSelf: 'stretch',
                                        }}
                                    >
                                        <label
                                            className='evalstyletxt'
                                            style={{ margin: 0 }}
                                        >
                                            {i18n.t('Ajouter un commentaire')}
                                        </label>
                                        <TextFieldComponent
                                            id="outlined-multiline-flexible"
                                            //label='     Entrer ici un commentaire...'
                                            placeholder={i18n.t('Entrer ici un commentaire')}
                                            multiline
                                            minRows={4}
                                            style={{ width: '100%', backgroundColor: 'white', borderRadius: '8px' }}
                                            // defaultValue={note?.commentaire}
                                            value={commentaire}
                                            onChange={(e) => setCommentaire(e.target.value)}
                                        />
                                        <Stack
                                            spacing={1}
                                            style={{ display: 'flex', flexDirection: 'row', margin: 0, alignSelf: 'stretch', justifyContent: 'flex-end', alignItems: 'flex-end' }}
                                        >
                                            {/*<Tooltip title={'Sauvegarder les données'}>
                                                <IconButton
                                                    onClick={() => {
                                                        setCommentaire('');
                                                    }}
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </Tooltip>*/}
                                            <Tooltip title={i18n.t('Sauvegarder les données')}>
                                                <IconButton
                                                    onClick={handleSaveEvaluation}
                                                >
                                                    <SaveOutlinedIcon style={{ color: '#5CC889' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Stack>
                                    </div>
                                </>
                            }
                        </div>
                        {!visualiseCvOnly &&
                            <div className='firsthspacer'></div>
                        }
                        {device=='desktop' &&
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignSelf: 'stretch',
                                justifyContent: ' flex-start',
                                alignItems: 'center'
                            }}
                        >
                            <Button
                                variant='contained'
                                startIcon={<Download />}
                                color='success'
                                style={{ ...buttonStylesGreen(false) }}
                                onClick={handleGeneratePdf}
                            >{i18n.t('Télécharger')}</Button>
                            {/*masquer pour v0*/}
                            {/*<Button >
                                <ShareOutlinedIcon style={{ color: '#272D3C' }} />
                            </Button>*/}
                        </div>
                        }
                    </>
                </div>
            </div>
        </Dialog>
    );
};

export default CvAnonyme;